import { Main } from '#components/Main.tsx'
import { ProjectHeader } from '#components/ProjectHeader.tsx'
import { ProjectMenu } from '#components/ProjectMenu.tsx'
import { Status as StatusView } from '#components/Status.tsx'
import { WithProject } from '#components/WithProject.tsx'
import { WithStatus } from '#components/WithStatus.tsx'

export const Status = ({
	statusId,
	projectId,
}: {
	statusId: string // e.g. '01H1XVCVQXR8619Z4NVVCFD20F'
	projectId: string // e.g. '$acme#project'
}) => (
	<WithProject id={projectId}>
		{({ project }) => (
			<WithStatus project={project} id={statusId}>
				{({ status }) => (
					<>
						<ProjectHeader project={project} />
						<Main class="container mt-3">
							<div class="row">
								<div class="col-12 col-lg-8 offset-lg-2">
									<StatusView status={status} />
								</div>
							</div>
						</Main>
						<ProjectMenu />
					</>
				)}
			</WithStatus>
		)}
	</WithProject>
)
